//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    logged_in() {
        return this.user
    }
  }
}
